import { Injectable } from "@angular/core";
import { ApiService } from "../api/api.service";
import { environment } from "@env/environment";

@Injectable({
	providedIn: "root",
})
export class PermissionsService {
	constructor(private apiService: ApiService) {}

	fetchPermissionsByUser(userId: number, options?: any) {
		return this.apiService.get(`${environment.api_base_url}/organization/users/${userId}/permissions`, options);
	}

	fetchPermissions(options?: any) {
		return this.apiService.get(`${environment.api_base_url}/organization/users/permissions`, options);
	}

	updateUserPermissions(userId: number, permissions: string[], options?: any) {
		return this.apiService.put(`${environment.api_base_url}/organization/users/${userId}/permissions`, permissions, options);
	}
}
